module.exports = __webpack_public_path__ + "img/104024.2079c357.png";